module.exports = __webpack_public_path__ + "img/754.08952c78.png";